import { useEffect, useMemo, useState } from 'react';
import api from '../../app/api';
import Loader from '../../components/Loader';
import Screen from "../../components/Screen";
import Table from '../../components/Table';
import { convertDateToDDMMYYYY, convertToLocal, ddmmyyyy } from '../../config/functions';
import useAlert from '../../hooks/useAlert';
import useAuth from '../../hooks/useAuth';

import { Box, Typography } from "@mui/material";
import { capitalFirstLetter } from "../../config/functions";
import Model from "../../components/model"
import EmptyData from '../../components/EmptyData';
import SubmitButton from '../../components/SubmitButton';
import { FormField } from "../dynamicSubscription/index";
import { useDispatch, useSelector } from 'react-redux';
import { addTicketReplyState, deleteTicket, setTicket, setTicketReplies, updateTicket } from './slice';
import { DeleteAlert } from '../../components/Swal Alert';
import { keys } from '../../config/keys';

let listStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'nowrap',
    borderBottom: '1px solid rgba(0,0,0,0.1)',
    padding: '6px 0px'
}
let descriptionStyle = {
    //   display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'nowrap',
    borderBottom: '1px solid rgba(0,0,0,0.1)',
    padding: '6px 0px'
}
export default function Default() {
    const [loading, setLoading] = useState(null)
    const { tickets, replies } = useSelector((state) => state.ticket)
    const dispatch = useDispatch()
    const { user } = useAuth()
    // const [tickets, setTickets] = useState([])
    // const [replies, setReplies] = useState([])
    const [commentData, setCommentData] = useState({})
    const [filter, setFilter] = useState({
company: "",
    branch: "",
    })
    const [deleteLoading, setDeleteLoading] = useState(null)
    const { showAlert } = useAlert()
    let labels = ["#", "Assigned by", "Assigned to", "Status", "Created At", "Actions"]
    const [show, setShow] = useState(null)
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const removeTicket = async (id) => {
        if (!await DeleteAlert()) return
        setDeleteLoading(id)
        try {
            let response = await api.delete(`/tickets/delete?_id=${id}`);
            if (response.data?.status) {
                dispatch(deleteTicket(response.data?.result))
                showAlert("Ticket deleted successfully.", "success")
            } else {
                showAlert(response.data.message, "danger")
            }
        } catch (error) {
            showAlert(error.message, "danger")
        } finally {
            setDeleteLoading(null)
        }
    }
    const getTickets = async () => {
        setLoading("initial");
        try {
            let response = await api.get(`/tickets/`, {
                params: {
                    userID: localStorage.getItem('_id'),
                    email: user.email,
                    page,
                    limit,
                    company: filter.company,
                    branch: filter.branch,
                }
            });
            if (response.data?.status) {
                dispatch(setTicket(response.data?.result))
            } else {
                showAlert(response.data.message, "danger")
            }
        } catch (error) {
            showAlert(error.message, "danger")
        } finally {
            setLoading(null);
        }
    }
    const changeStatus = async (ticketID, status) => {
        setLoading("replies");
        try {
            let response = await api.put(`/tickets/updateStatus`, { ticketID, status });
            if (response.data?.status) {
                dispatch(updateTicket(response.data?.result))
                showAlert("Status updated successfully.", "success")
            } else {
                showAlert(response.data.message, "danger")
            }
        } catch (error) {
            showAlert(error.message, "danger")
        } finally {
            setLoading(null);
        }
    }
    const getTicketReply = async (ticketID) => {
        setLoading("replies");
        try {
            let response = await api.get(`/ticket-reply/?ticketID=${ticketID}`);
            if (response.data?.status) {
                dispatch(setTicketReplies(response.data?.result))
            } else {
                showAlert(response.data.message, "danger")
            }
        } catch (error) {
            showAlert(error.message, "danger")
        } finally {
            setLoading(null);
        }
    }
    const addTicketReply = async () => {
        setLoading("addReply");
        try {
            let response = await api.post(`/ticket-reply/add`, {
                ticketID: show._id,
                userID: localStorage.getItem('_id'),
                comments: commentData.text

            });
            if (response.data?.status) {
                setCommentData({ text: '' })
                dispatch(addTicketReplyState(response.data?.result))
                showAlert("Comment added successfully.", "success")
            } else {
                showAlert(response.data.message, "danger")
            }
        } catch (error) {
            showAlert(error.message, "danger")
        } finally {
            setLoading(null);
        }
    }
    const data = useMemo(() => {
        if (!tickets || tickets.length === 0) return [];
        return tickets.map((item) => {
            return {
                data: item,
                fields: [
                    "#",
                    item?.name,
                    <td>{item?.user?.name || item?.userID?.name}</td>,
                    <td>{item.profileEmails ? item?.profileEmails?.map(pe => pe.name).join(", ") : item?.profileEmailID?.map(pe => pe.name).join(", ")}</td>,
                    <td>
                        <select
                            className="form-select"
                            onChange={(e) => changeStatus(item._id, e.target.value)}
                            style={{ width: '140px', marginRight: '10px' }}
                            aria-label="Default select example"
                        >
                            <option
                                value={'pending'}
                                selected={item.status == 'pending'}
                            >
                                Pending
                            </option>
                            <option
                                value={'completed'}
                                selected={item.status == 'completed'}
                            >
                                Completed
                            </option>

                        </select>
                    </td>,
                    convertToLocal(item?.createdAt),
                    <div className="d-flex gap-3">
                        {
                            <i
                                className="bi bi-eye text-primary"
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                    setShow(item)
                                }}
                            ></i>
                        }
                        {item?._id == deleteLoading ? (
                            <div className="d-flex align-items-center justify-content-center ">
                                <Loader loading={deleteLoading != null} color={"red"} />
                            </div>
                        ) : (
                            <i
                                className="bi bi-trash text-danger"
                                style={{ cursor: "pointer" }}
                                onClick={() => removeTicket(item._id)}
                            ></i>
                        )}
                    </div>

                ].filter((it) => it),
            };
        });
    }, [tickets, deleteLoading, loading]);
    useEffect(() => {
        getTickets()

    }, [filter, page, limit])
    useEffect(() => {
        if (show != null) {
            getTicketReply(show._id)
        }

    }, [show])
    const onView = (item) => {
        window.open(`${keys.BASE_LOCAL_URL}/${item.attachment}`, "_blank", "noreferrer");
    };
    console.log(show)
    return (
        <Screen
            loading={loading == "initial"}
            filter={filter}
            setFilter={setFilter}
            showBranchFilter={true}
            faqsId={"tickets"}
            flow={[
                { label: `Tickets`, to: `/tickets` },
                { label: "Home", to: "/" },
                { label: `Tickets`, to: `/tickets` },
            ]}
        >
            {show && <Model title="Ticket Details" show={show} handleClose={() => setShow(null)}>
                <Box sx={listStyle}>
                    <Typography sx={{ fontWeight: 'bold' }}>(Checklist / RA / Audit) Title</Typography>
                    <Typography>{show?.originatorFeatureTitle}</Typography>
                </Box>
                <Box sx={listStyle}>
                    <Typography sx={{ fontWeight: 'bold' }}>Question</Typography>
                    <Typography>{show?.taskQuestion}</Typography>
                </Box>
                <Box sx={listStyle}>
                    <Typography sx={{ fontWeight: 'bold' }}>Added by</Typography>
                    <Typography>{show?.user?.name}</Typography>
                </Box>
                <Box sx={listStyle}>
                    <Typography sx={{ fontWeight: 'bold' }}>Added for</Typography>
                    <Typography>{show?.profileEmails?.map(pe => pe.name).join(", ") || 'None'}</Typography>
                </Box>
                <Box sx={listStyle}>
                    <Typography sx={{ fontWeight: 'bold' }}>Status</Typography>
                    {/* <Typography>{show?.status}</Typography> */}
                    <select
                        className="form-select"
                        onChange={(e) => changeStatus(show._id, e.target.value)}
                        style={{ width: '140px', marginRight: '10px' }}
                        aria-label="Default select example"
                    >
                        <option
                            value={'pending'}
                            selected={show.status == 'pending'}
                        >
                            Pending
                        </option>
                        <option
                            value={'completed'}
                            selected={show.status == 'completed'}
                        >
                            Completed
                        </option>

                    </select>

                </Box>
                <Box sx={listStyle}>
                    <Typography sx={{ fontWeight: 'bold' }}>Date added</Typography>
                    <Typography>{convertToLocal(show?.createdAt) || 'None'}</Typography>
                </Box>
                {show.attachment && <Box sx={listStyle}>
                    <Typography sx={{ fontWeight: 'bold' }}>Attachment</Typography>
                    <Typography onClick={() => onView(show)} sx={{ textDecoration: 'underline', color: 'blue', cursor: 'pointer' }}>{'Download Attachment'}</Typography>
                </Box>}
                <Box sx={descriptionStyle}>
                    <Typography sx={{ fontWeight: 'bold' }}>Description</Typography>
                    <Typography>{capitalFirstLetter(show?.comments) || 'None'}</Typography>
                </Box>
                <br />
                <Typography sx={{ fontWeight: 'bold' }}>Comments</Typography>
                <div className='mt-3'>
                    <FormField
                        field={{
                            value: commentData?.text,
                            setValue: (value) => setCommentData({ ...commentData, text: value }),
                            label: "Enter a comment",
                            placeholder: "Enter a comment",
                            type: "longtext",
                            id: "text",
                        }}
                        isNotRow={true}
                    />
                    <div className="d-flex justify-content-center mt-4 mb-4">
                        <SubmitButton
                            title={"Add Comment"}
                            loading={loading == 'addReply'}
                            onClick={() => {
                                addTicketReply()
                            }}
                            color={"success"}
                            loaderColor={"white"}
                            disabled={
                                commentData?.text == ""
                            }
                        />
                    </div>
                </div>
                <Loader loading={loading == 'replies'}>
                    {replies?.map((item, index) => (
                        <div key={index} className="col-md-12 col-12">
                            <div className="card pt-4" style={{ backgroundColor: localStorage.getItem('_id') == item.userID?._id && '#E6FFEB' }}>
                                <div className="card-body">
                                    <Box sx={{ display: 'flex', alignItems: 'center' }}><h6 style={{ padding: '0', fontWeight: 'bold' }}>Added By: </h6><h6 className="mx-2">{item.userID?.name}{localStorage.getItem('_id') == item?.userID?._id && " (You)"}</h6></Box>
                                    <Box sx={{ display: 'flex', alignItems: 'center' }}><h6 style={{ padding: '0', fontWeight: 'bold' }}>Date Added: </h6><h6 className="mx-2">{convertToLocal(item.createdAt)}</h6></Box>
                                    <Box sx={{ display: 'flex' }}><h6 style={{ padding: '0', paddingRight: '10px', fontWeight: 'bold' }} >{`Comment: `}</h6><h6 className="">{item.comments}</h6></Box>
                                </div>
                            </div>
                        </div>
                    ))}
                </Loader>
            </Model>}
            <Table
                labels={labels}
                data={data}
                page={page}
                limit={limit}
                setPage={setPage}
                setLimit={setLimit}
            // totalData={totalMsDocs}
            />
        </Screen>
    )
}
